export const truncateString = (str, num) => {
    if (str.length <= num) {
        return str;
    } else {
        return str.slice(0, num > 3 ? num - 3 : num).trim() + '...';
    }
}


// WEBPACK FOOTER //
// ./src/utils/truncateString.js